import React from 'react';
import { render } from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'gijgo/css/gijgo.min.css';
//import 'CSS/deadline-1.0.css';
import 'bootstrap';
import ConfigLoader from 'Components/ConfigLoader';
import { App } from './App';
// setup fake backend
//import { configureFakeBackend } from './_helpers';
//configureFakeBackend();

render(
    <ConfigLoader ready={() => <App />}/>,
    document.getElementById('app')
);